import CompScroll from "./CompScroll";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function MainBusiness() {
  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      <div className="business">
        <div className="section-txt-wrap">
          {pc ? (
            <>
              <h2 className="section-title">
                <span className="basic-block">헬리오센의 디지털 전환을</span>
                <span className="basic-block">주도할 핵심기술</span>
              </h2>
              <div className="section-content">
                <p>4차 산업혁명 핵심 ICT 기술과 공간 정보와의</p>
                <p>연결로 새로운 가치를 만들어가는 전문 벤처기업입니다.</p>
              </div>
            </>
          ) : (
            <>
              <h2 className="section-title">
                <span className="basic-block">헬리오센의 디지털</span>
                <span className="basic-block">전환을 주도할 핵심기술</span>
              </h2>
              <div className="section-content">
                <p>4차 산업혁명 핵심 ICT 기술과 공간 정보와의</p>
                <p>연결로 새로운 가치를 만들어가는</p>
                <p>전문 벤처기업입니다.</p>
              </div>
            </>
          )}
          <Link className="link-fit" to="/business/digitaltwin">
            <button className="section-btn-wrap">
              <span className="section-btn-more">자세히 보기</span>
              <span className="section-btn"></span>
            </button>
          </Link>
        </div>
        <div className="business-slider">
          <div className="business-slider-list">
            {pc ? (
              <Swiper slidesPerView={"auto"} spaceBetween={30}>
                <SwiperSlide>
                  <Link className="business-link" to="/business/digitaltwin">
                    <div className="business-slider-item">
                      <div className="business-slider-txt-wrap">
                        <p className="business-img digitaltwin"></p>
                        <h3 className="business-slider-title">DIGITAL TWIN</h3>
                      </div>
                      <div>
                        <div className="business-slider-content">
                          <p>디지털 트윈은 산업의</p>
                          <p>디지털 전환을 주도할 핵심기술이며</p>
                          <p>기술을 바탕으로 서비스를 제공합니다.</p>
                        </div>
                        <p className="link-fit">
                          <button className="section-btn"></button>
                        </p>
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link className="business-link" to="business/geo-iot">
                    <div className="business-slider-item">
                      <div className="business-slider-txt-wrap">
                        <p className="business-img geoiot"></p>
                        <h3 className="business-slider-title">Geo-IoT</h3>
                      </div>
                      <div>
                        <div className="business-slider-content">
                          <p>IoT센서 수집/분석/예측 데이터를</p>
                          <p>바탕으로 공간 정보와 연계한</p>
                          <p>서비스를 제공합니다.</p>
                        </div>
                        <p className="link-fit">
                          <button className="section-btn"></button>
                        </p>
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link className="business-link" to="/business/gis">
                    <div className="business-slider-item">
                      <div className="business-slider-txt-wrap">
                        <p className="business-img gis"></p>
                        <h3 className="business-slider-title">GIS</h3>
                      </div>
                      <div>
                        <div className="business-slider-content">
                          <p>사람이 살아가는데 필요한 많은</p>
                          <p>정보를 공간 정보와 결합한</p>
                          <p>시스템을 제공합니다.</p>
                        </div>
                        <p className="link-fit">
                          <button className="section-btn"></button>
                        </p>
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link className="business-link" to="/business/ai">
                    <div className="business-slider-item">
                      <div className="business-slider-txt-wrap">
                        <p className="business-img ai"></p>
                        <h3 className="business-slider-title">AI</h3>
                      </div>
                      <div>
                        <div className="business-slider-content">
                          <p>인공지능을 통한</p>
                          <p>3D 객체 분류 및</p>
                          <p>인식 기술을 제공합니다.</p>
                        </div>
                        <p className="link-fit">
                          <button className="section-btn"></button>
                        </p>
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
              </Swiper>
            ) : (
              // 모바일
              <Swiper slidesPerView={"auto"} spaceBetween={15}>
                <SwiperSlide>
                  <div className="business-slider-item">
                    <Link className="business-link" to="/business/digitaltwin">
                      <div className="business-slider-txt-wrap">
                        <p className="business-img digitaltwin"></p>
                        <h3 className="business-slider-title">DIGITAL TWIN</h3>
                      </div>
                      <div>
                        <div className="business-slider-content">
                          <p>디지털 트윈은 산업의 디지털</p>
                          <p>전환을 주도할 핵심기술이며</p>
                          <p>기술을 바탕으로 서비스를</p>
                          <p>제공합니다.</p>
                        </div>
                        <p className="link-fit">
                          <button className="section-btn"></button>
                        </p>
                      </div>
                    </Link>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="business-slider-item">
                    <Link className="business-link" to="business/geo-iot">
                      <div className="business-slider-txt-wrap">
                        <p className="business-img geoiot"></p>
                        <h3 className="business-slider-title">Geo-IoT</h3>
                      </div>
                      <div>
                        <div className="business-slider-content">
                          <p>IoT센서 수집/분석/예측</p>
                          <p> 데이터를 바탕으로 공간 정보</p>
                          <p>와 연계한 서비스를 제공합니</p>
                          <p>다.</p>
                        </div>
                        <p className="link-fit">
                          <button className="section-btn"></button>
                        </p>
                      </div>
                    </Link>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="business-slider-item">
                    <Link className="business-link" to="/business/gis">
                      <div className="business-slider-txt-wrap">
                        <p className="business-img gis"></p>
                        <h3 className="business-slider-title">GIS</h3>
                      </div>
                      <div>
                        <div className="business-slider-content">
                          <p>사람이 살아가는데 필요한</p>
                          <p>많은 정보를 공간 정보와</p>
                          <p>결합한 시스템을 제공합니</p>
                          <p>다.</p>
                        </div>
                        <p className="link-fit">
                          <button className="section-btn"></button>
                        </p>
                      </div>
                    </Link>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="business-slider-item">
                    <Link className="business-link" to="/business/ai">
                      <div className="business-slider-txt-wrap">
                        <p className="business-img ai"></p>
                        <h3 className="business-slider-title">AI</h3>
                      </div>
                      <div>
                        <div className="business-slider-content">
                          <p>인공지능을 통한</p>
                          <p>3D 객체 분류 및</p>
                          <p>인식 기술을 제공합니다.</p>
                        </div>
                        <p className="link-fit">
                          <button className="section-btn"></button>
                        </p>
                      </div>
                    </Link>
                  </div>
                </SwiperSlide>
              </Swiper>
            )}
          </div>
        </div>
      </div>
      <CompScroll value={2} />
    </>
  );
}

export default MainBusiness;
